import seoClients from "../../data/seoClients.json";
import Reviews from "../../componets/Reviews";

const Section11 = () => {
  // Convert seoClients into the format Reviews expects
  const normalizedClients = seoClients.map(client => ({
    name: client.title,
    img: client.imgUrl,
    text: client.text,
  }));

  return (
    <div className="w-full Section9 mt-[40px] md:mt-0 p-[2%] text-center mb-[40px] md:mb-[3%] bg-cover">
      <div className="w-full section4-container">
        <Reviews testimonials={normalizedClients} seo={true} />
      </div>
    </div>
  );
};

export default Section11;